/**
 * Optická dĺžka kábla = dĺžka úseku + návin na stĺpoch.
 *
 * `length_meters` je dĺžka úseku medzi stĺpmi (pri podporných stĺpoch už
 * lomená trasa). Návin (rezerva) je vlákno navyše, ktoré tam reálne je:
 *  - pri krabici musí kábel zísť z vrchu stĺpa dolu do krabice a vrátiť sa,
 *    lebo krabica býva v dosahu, nie hore,
 *  - pri podpornom stĺpe je to stočená rezerva pre budúce zásahy.
 *
 * Návin je uložený PO STĹPOCH (`cable.reserves`), takže pokryje aj stĺp
 * v strede kábla. Do útlmu ide TÁTO dĺžka, nie `length_meters`.
 */
import { Cable } from '../types';

/** Dĺžka úseku bez návinu, v metroch. */
export const cableSpanLength = (cable?: Cable | null): number =>
  Number(cable?.length_meters) || 0;

/** Súčet návinu na všetkých stĺpoch kábla, v metroch. */
export const cableReserve = (cable?: Cable | null): number =>
  (cable?.reserves || []).reduce((sucet, z) => sucet + (Number(z?.meters) || 0), 0);

/** Návin na konkrétnom stĺpe, v metroch (0 ak tam žiadny nie je). */
export const cableReserveAtPole = (cable: Cable | null | undefined, poleId: number): number => {
  const z = (cable?.reserves || []).find((x) => Number(x?.pole_id) === poleId);
  return Number(z?.meters) || 0;
};

/** Skutočná dĺžka vlákna v kábli = úsek + návin. Toto ide do útlmu. */
export const cableOpticalLength = (cable?: Cable | null): number =>
  cableSpanLength(cable) + cableReserve(cable);

/** Popis pre UI, napr. „118,3 m + 8 m návin = 126,3 m". */
export const cableLengthLabel = (cable?: Cable | null): string => {
  const span = cableSpanLength(cable);
  const rez = cableReserve(cable);
  if (!rez) return `${span.toFixed(1)} m`;
  return `${span.toFixed(1)} m + ${rez.toFixed(1)} m návin = ${(span + rez).toFixed(1)} m`;
};
